<template>
    <div class="message-container">
        <slide-content :routesParams="routesParams">
            <router-view></router-view>
        </slide-content>
    </div>    
</template>
<script>
import SlideContent from '../components/PageSlider/SlideContent.vue' 
export default {
    components : {
        SlideContent
    },
    data(){
        return{
            routesParams : [
                {
                    title : 'Recados(1)',
                    path : '/message/1'
                },
                {
                    title : 'Recados(2)',
                    path : '/message/2'
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
    .message-container{
        height: 100vh;
    }
    @media only screen and (min-width: 700px){
        .message-container{
            height: 100%;
        }
    }
</style>
